const elementExists = document.querySelectorAll('.select-css-clearable');

elementExists.forEach(selectWrap => {
  if (typeof selectWrap !== 'undefined' && elementExists !== null) {
    const select = selectWrap.querySelector('select');
    if (select.value !== '') {
      selectWrap.classList.add('clear');
    }
    select.onchange = () => {
      if (select.value !== '') {
        selectWrap.classList.add('clear');
        select.form.submit();
      } else {
        selectWrap.classList.remove('clear');
        select.form.submit();
      }
    };
    const selectClear = selectWrap.querySelector('.select-clear');
    if (selectClear) {
      selectClear.onclick = () => {
        select.selectedIndex = 0;
        if (select.value !== '') {
          selectWrap.classList.add('clear');
        } else {
          selectWrap.classList.remove('clear');
        }
        select.form.submit();
      };
    }
  }
});
